import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 22",
  fill: "#6B93C0",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.575 21.538H3.712C1.666 21.538 0 20.028 0 18.173v-11.4c0-1.855 1.666-3.366 3.712-3.366h8.863c2.047 0 3.713 1.51 3.713 3.366v11.4c0 1.855-1.666 3.366-3.713 3.366zM3.712 5.09c-1.025 0-1.856.753-1.856 1.683v11.4c0 .93.83 1.683 1.856 1.683h8.863c1.026 0 1.857-.753 1.857-1.683v-11.4c0-.93-.831-1.683-1.857-1.683H3.712zM20 16.07V3.365C20 1.51 18.334 0 16.288 0H5.986c-.51 0-.928.379-.928.841 0 .463.418.842.928.842h10.302c1.025 0 1.856.753 1.856 1.682V16.07c0 .462.418.841.928.841s.928-.379.928-.841z" }, null, -1 /* HOISTED */)
  ])))
}